module.exports = __webpack_public_path__ + "img/img-apart-inicial.d0613dc6.png";